import * as z from "zod";

export const verifyContextualSetup = {
  name: "verifyContextualSetup" as const,
  input: z.object({
    step: z.enum([
      "dns",
      "shopify_pixel",
      "embedded_script",
      "detect_provider",
    ]),
    domain: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string(),
    provider: z.string().optional(),
    nameservers: z.array(z.string()).optional(),
  }),
};
